import axiosHttp from "./interceptor.service";

const postQuestion = (data) => {
  return axiosHttp.post("/feedback/createQuestion", data);
};

const getQuestion = ({ page, limit, sort, search } = {}) => {
  return axiosHttp.get("/feedback/getQuestion", {
    params: { page, limit, sort, search },
  });
};

const updateQuestion = (id, data) => {
  return axiosHttp.put(`/feedback/updateQuestion/${id}`, data);
};

const deleteQuestion = (id) => {
  return axiosHttp.delete(`/feedback/deleteQuestion/${id}`);
};

export { postQuestion, getQuestion, updateQuestion, deleteQuestion };
